export default __webpack_public_path__ + "static/media/fa-light-300.3c69f3ae.eot";